export default function(h, row, index) {
    let _text = ''
    if (row.ag_invoice_number != null)
        _text = row.ag_invoice_number;
        if (row.ag_invoice_date != null)
            _text += ' от ' + row.ag_invoice_date.substring(0,10);

    return <span><span class="vouchers_table__ag_invoice_date">{_text}</span></span>
}